import { CONNECT_PAGE_PATHS } from "@vidimo/shared/contracts";
import { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { lazyChunk } from "@/lib/lazy-chunk";

const InstagramConnectResult = lazyChunk(
  () => import("@/connect/instagram-connect-result")
);
const WhatsAppConnect = lazyChunk(() => import("@/connect/whatsapp-connect"));

/**
 * The router a connect page boots into, in place of the shell's. The shell
 * registers for push and retries the registration outbox, and both ask the API
 * for a session; on the connect origin (ADR-0137) that request would carry the
 * host's cookie from the one origin that must never send it. These pages need
 * no session: a signed token or the API's result code is all they carry.
 */
export function ConnectApp() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        <Route path={CONNECT_PAGE_PATHS.instagram}>
          <InstagramConnectResult />
        </Route>
        <Route path={CONNECT_PAGE_PATHS.whatsapp}>
          <WhatsAppConnect />
        </Route>
      </Switch>
    </Suspense>
  );
}
